import {connect} from 'react-redux';
import {setAppEndpoint} from '../../../reducers/app/actions';
import {pingNode} from './actions';
import EndpointsDropdown from "../../../components/endpoints-dropdown";

const mapStateToProps = state => ({
  endpoints: state.config.nodes,
  endpointId: state.app.endpointId,
  isEndpointAvailable: state.app.isEndpointAvailable
});

const mapDispatchToProps = dispatch => ({
  onEndpointSet: endpointId => dispatch(setAppEndpoint(endpointId)),
  onNodePing: () => dispatch(pingNode())
});

export default connect(mapStateToProps, mapDispatchToProps)(EndpointsDropdown);



// WEBPACK FOOTER //
// ./src/page/header/endpoint-dropdown/index.jsx